import React from "react";

const LinkButtonTitle = ({ title, children }) => {
  return (
    <div className="flex items-center justify-between mb-6 px-4 py-4 rounded-lg bg-[linear-gradient(90deg,#1D2A9D_0%,#ffffff_100%)]">
      <h2 className="text-xl font-semibold text-white tracking-tight">
        {title}
      </h2>
      {children}
    </div>
  );
};

export default LinkButtonTitle;
